'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

NewPasswordValidatorsDirective=function(_BaseControllerBacked){_inherits(NewPasswordValidatorsDirective,_BaseControllerBacked);function NewPasswordValidatorsDirective(){_classCallCheck(this,NewPasswordValidatorsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(NewPasswordValidatorsDirective,[{key:'objectBindings',get:function()
{
return['newPassword'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/newPasswordValidatorsDirective/newPasswordValidatorsTemplate';
}},{key:'controller',get:function()

{
return NewPasswordValidatorsDirectiveController;
}}]);return NewPasswordValidatorsDirective}(BaseControllerBackedDirective);let


NewPasswordValidatorsDirectiveController=function(){_createClass(NewPasswordValidatorsDirectiveController,null,[{key:'$inject',get:function()
{
return[];
}}]);

function NewPasswordValidatorsDirectiveController(){var _this2=this;_classCallCheck(this,NewPasswordValidatorsDirectiveController);
this._validators=[{
label:'2 Letters',
isValid:function(){return _.exists(_this2.newPassword)&&_.exists(_this2.newPassword.match(/[a-z].*[a-z]/i))}},
{
label:'2 Numbers',
isValid:function(){return _.exists(_this2.newPassword)&&_.exists(_this2.newPassword.match(/[0-9].*[0-9]/))}},
{
label:'8 Character Minimum',
isValid:function(){return _.exists(_this2.newPassword)&&_this2.newPassword.length>=8}}];

}_createClass(NewPasswordValidatorsDirectiveController,[{key:'validators',get:function()

{
return this._validators;
}}]);return NewPasswordValidatorsDirectiveController}();



module.exports=NewPasswordValidatorsDirective;
//# sourceMappingURL=newPasswordValidatorsDirective.js.map
